exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vm--overlay[data-v-7f73d532]{background:#000;opacity:.7}.overlay-enter[data-v-7f73d532],.overlay-leave-to[data-v-7f73d532]{opacity:0}.overlay-enter-active[data-v-7f73d532],.overlay-leave-active[data-v-7f73d532]{transition:all .3s}", ""]);

// exports
